import React from "react";

const Stats = () => {
  return (
    <section className="stats">
      <div className="wrapper stats-wrapper flex">
        <div className="center">
          <h3>7million</h3>
          <p className="stats-small-text">Completed Jobs</p>
        </div>
        <div className="center">
          <h3>30k+</h3>
          <p className="stats-small-text">Worldwide Client</p>
        </div>
        <div className="center">
          <h3>13billion</h3>
          <p className="stats-small-text">Dollar Payout</p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
